import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import fetchProductListDownload from './fetchProductListDownload'

export const productListDownloadAdapter = createEntityAdapter()

export const productListDownloadSlicer = createSlice({
  name: 'product/download',
  initialState: productListDownloadAdapter.getInitialState({
    status: 'idle',
    url: {},
    errors: null
  }),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchProductListDownload.pending, state => {
      state.status = 'loading'
    })
    builder.addCase(
      fetchProductListDownload.rejected,
      (state, { payload }) => {
        state.status = 'error'
        state.errors = payload
      }
    )
    builder.addCase(
      fetchProductListDownload.fulfilled,
      (state, { payload }) => {
        state.status = 'loading'
        state.url = payload
      }
    )
  }
})

const reducer = productListDownloadSlicer.reducer
export default reducer
